var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{key:_vm.tinymceFlag,ref:"timyEditor",attrs:{"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }